// extracted by mini-css-extract-plugin
export var signUp = "SignUp-module--signUp--yu9iI";